<template>
    <div id="customer-service-root">
        <vs-popup title="Cliente" 
        :active.sync="isActive"
        @close="$emit('isActiveFalse')"
        style="border-radius: 10px !important;"
        id="customer-services-modal"
        >
            <vs-tabs v-model="selectedTab" ref="tabCustomersModal">
                <vs-tab label="Novo Cliente">
                    <div class="flex justify-around items-center mt-6" :style="marginBottom ? 'margin-bottom: 15em;' : ''">
                        <vs-input
                        name="Nome"
                        icon-no-border
                        icon="icon icon-user"
                        icon-pack="feather"
                        label-placeholder="Nome"
                        v-model="customer.name"/>
                        
                        <vx-input-phone
                            label="Número de Telefone"
                            class="mb-5"
                            name="telefone"
                            v-model="customer.phone_number"
                            :preferredCountries="['BR']"
                            :defaultCountryCode="'BR'"
                            @onOpen="marginBottom = true"
                            @onClose="marginBottom = false"
                            @update="setInternational"
                            style="width:25em;"
                            v-validate="'required'"
                            :reload="activeLocal"
                        />

                    </div>
                </vs-tab>

                <vs-tab label="Cliente Existente">

                    <div class="flex items-center justify-between mt-4">
                        <vs-dropdown vs-trigger-click class="cursor-pointer">
                            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                                <span class="mr-2">
                                    {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                                    {{
                                    customersList.length - currentPage * itemsPerPage > 0
                                    ? currentPage * itemsPerPage
                                    : customersList.length
                                    }} of {{ queriedItems }}
                                </span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                            </div>
                            <vs-dropdown-menu>
                                <vs-dropdown-item @click="itemsPerPage=4">
                                    <span>4</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="itemsPerPage=10">
                                    <span>10</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="itemsPerPage=15">
                                    <span>15</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="itemsPerPage=20">
                                    <span>20</span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>

                        <div class="flex items-center">
                            <vs-input 
                                v-model="searchQuery" 
                                @keydown.enter.prevent="searchCustomers()" 
                                style="margin-right: 10px;" 
                            />
                            <feather-icon 
                                style="background-color:#279dfb; border-radius:6px; cursor:pointer; color:white;" 
                                class="p-2" 
                                @click="searchCustomers()" 
                                svgClasses="w-6 h-6 stroke-current" 
                                icon="SearchIcon" 
                            />
                        </div>
                    </div>

                    <vs-table
                        class="mr-2"
                        ref="table"
                        noDataText="Sem dados disponíveis"
                        v-model="selected"
                        :data="customersList"
                        :max-items="itemsPerPage"
                    >
                        <template slot="thead">
                            <vs-th sort-key="tr.name">Nome</vs-th>
                            <vs-th sort-key="tr.phone_number">Telefone</vs-th>
                        </template>
                        
                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" class="customers-list">
                                <vs-td :data="tr.name">
                                    {{ tr.name }}
                                </vs-td>

                                <vs-td :data="tr.phone_number">
                                    {{ parsePhoneNumber(tr.phone_number) }} 
                                </vs-td>
                            </vs-tr>
                        </template>

                    </vs-table>
                </vs-tab>
            </vs-tabs>

            <vs-pagination
                :max="7"
                class="mt-3"
                :total="totalPages"
                v-model="currentPage"
            />

            <vs-button 
            class="btn-drop px-3 mt-5 mr-3 mt-3 mb-2" 
            type="filled" 
            icon="keyboard_arrow_right" 
            icon-after style="float: right !important; border-radius: 12px;"
            @click="selectedTab === 0 ? addCustomer() : oldCustomer()"
            :disabled="(!customer.name || !customer.phone_number) && selectedTab === 0"
           >
               Continuar
           </vs-button>

        </vs-popup>
    </div>
</template>

<script>
    import customerApi from '@/http/requests/customer';
    import moduleCustomer from '@/store/customer/moduleCustomer'
    import Pagination from "@/components/pagination/pagination.vue";
    import { maskPhoneNumber } from "@/utils";
    import VxInputPhone from "@/components/vx-input-phone/index.vue";

    export default {
        name: 'CustomerModal',

        components: {
            Pagination,
            VxInputPhone
        },
        props: {
            isActive: {
                type: Boolean,
                required: true
            },
        },
        emits: [
            'isActiveFalse',
        ],

        data() {
            return {
                searchQuery: null,
                selected: null,
                selectedTab: 0,
                customer: {
                    name: '',
                    phone_number: '',
                    international_phone_number: ''
                },
                searched: false,
                currentPage: 1,
                itemsPerPage: 4,
                marginBottom: false
            }
        },
        methods: {
            parsePhoneNumber(number) {
                return maskPhoneNumber(number);
            },
            setInternational(phone){
                if (phone && phone.e164){
                    this.customer.international_phone_number = phone.e164.replace('+', '')
                }
            },
            async searchCustomers() {
                await this.fetchCustomers();
                this.currentPage = 1;
            },
            async fetchCustomers() {

                this.$store.dispatch("customer/fetch", {
                    ...this.searchObject,
                    search_query: this.searchQuery
                })
            },
            async addCustomer() {
                this.customer.is_favorite    = 0;
                this.customer.is_blacklisted = 0;

                if (this.customer.international_phone_number !== null) {
                    this.customer.phone_number = this.customer.international_phone_number;
                    delete this.customer.international_phone_number;
                }

                await customerApi.add({customer: this.customer, chosenGroups: []})
                    .then((response) => {
                        this.$vs.notify({
                            color: 'success',
                            title: "Adicionar Contato",
                            text: 'O contato foi adicionado com sucesso.',
                        });
                        
                        this.selected = response.data.data.createCustomer

                        this.$emit('customerDocument', this.selected)
                    }).catch((error) => {
                    console.error(error)
                })
            },
            oldCustomer() {
                if (!this.selected) {
                    return this.$vs.notify({
                        color: 'danger',
                        title: 'Atenção!',
                        text: 'Para continuar escolha um cliente!'
                    });
                }
                this.$emit('customerDocument', this.selected)
            },
        },
        watch: {
            isActive(val) {
                if (val) {
                    this.selected = null
                    setTimeout(() => {
                        this.$refs.tabCustomersModal.value = 1;
                        this.$refs.tabCustomersModal.$data.childActive = 1;
                    }, 35);
                }
            },
            currentPage() {
                this.fetchCustomers()
            },
            itemsPerPage() {
                if (this.currentPage === 1) {
                    return this.fetchCustomers()
                } 

                this.currentPage = 1
            }
        },
        computed: {
            totalPages() {
                return Math.ceil(this.customersList.length / 4);
            },
            customersList() {
                return this.$store.state.customer.customers
                ? this.$store.state.customer.customers.items
                : []
            },
            queriedItems() {
                return this.$store.state.customer.customers
                ? this.$store.state.customer.customers.total_items
                : 0
            },
            totalPages() {
                return this.$store.state.customer.customers
                ? this.$store.state.customer.customers.total_pages
                : 1
            },
            searchObject() {
                return {
                    deleted_at: null,
                    pagination_page: this.currentPage,
                    pagination_limit: this.itemsPerPage
                }
            },
            activeLocal: {
                get() {
                    return this.isActive
                },set() {}
            },
        },
        created() {
            if (!moduleCustomer.isRegistered) {
                this.$store.registerModule('customer', moduleCustomer)
                moduleCustomer.isRegistered = true
            }

            this.fetchCustomers()
        },
}
</script>

<style>
    .customers-list {
        height: 3.8em !important;
        box-shadow: 0 4px 20px 0 rgb(0 0 0 / 5%) !important;
    }
    #customer-services-modal * {
        margin: 0;
    }
    #customer-services-modal div.vs-popup {
        width: 650px !important;
    }
    #customer-services-modal html {
        line-height: 1.5;
        letter-spacing: 0.02rem;
    }
    #customer-services-modal table.vs-table.vs-table--tbody-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;
        background-color: white !important;
    }
    #customer-services-modal .vs-con-tbody.vs-table--tbody {
        border: 0 !important;
    }
    #customer-services-modal tbody > tr {
        height: 5em;
        box-shadow: 0 4px 20px 0 rgb(0 0 0 / 5%);
    }
    #customer-services-modal thead > tr {
        background-color: transparent !important;
    }
    #customer-services-modal .vs-table-text {
        text-transform: uppercase;
        font-size: 12px;
    }
    #customer-services-modal input.input-search.vs-table--search-input {
        height: 45px;
    }
</style>